import styled, { css } from 'styled-components';

import { Div } from './Generic';
import SC from './SC';

interface FadeInProps {
  when?: boolean;
  delay?: number;
}

const FadeIn = styled(Div)<SC<FadeInProps>>`
  ${({ sc: { when = true, delay = 0 } = {} }) => {
    const name = `fade-in-${delay ? 'delayed' : ''}`;

    return css`
      ${when && css`
        animation: ${name} ${(delay + 200) / 1000}s ease-in;
      `}

      @keyframes ${name} {
        0% { opacity: 0; }
        ${delay && css`${(1 - (delay / (delay + 200))) * 100}% { opacity: 0; }`}
        100% { opacity: 1; }
      }`;
  }}
`;

export default FadeIn;
